// src/pages/UserLogReport.js
import React, { useEffect, useState } from "react";
import axios from "axios";
import TopNav from "../../components/navigation/TopNav";
import TimeRangeSelector from "../../components/helpers/TimeRangeSelector";
import { useTranslation } from "react-i18next";
import { maskLogNotes } from "../../components/helpers/maskHelpers";

export default function UserLogReport() {
  const { t } = useTranslation();
  const [logs, setLogs] = useState([]);
  const [filteredLogs, setFilteredLogs] = useState([]);
  const [statusFilter, setStatusFilter] = useState("all");
  const [timeRange, setTimeRange] = useState({ start: "", end: "" });

  useEffect(() => {
    axios.defaults.headers.common["Authorization"] = `Bearer ${localStorage.getItem("token")}`;

    axios
      .get(`${process.env.REACT_APP_API_URL}/user/detailed-logs`)
      .then((res) => setLogs(res.data))
      .catch(() => setLogs([]));
  }, []);

  useEffect(() => {
    const filtered = logs.filter((log) => {
      const created = new Date(log.created_at);
      const start = new Date(timeRange.start);
      const end = new Date(timeRange.end);
      const statusMatch = statusFilter === "all" || log.status === statusFilter;
      const timeMatch = created >= start && created <= end;
      return statusMatch && timeMatch;
    });

    setFilteredLogs(filtered);
  }, [logs, statusFilter, timeRange]);

  return (
    <>
      <TopNav title={t("logs.title")} mode="main" />

      <div className="main-content">
        <div className="dashboard-container">
          <h1>{t("logs.title")}</h1>

          <div className="dashboard-form-row" style={{ gap: "2rem", marginBottom: "1rem" }}>
            <div>
              <TimeRangeSelector onRangeChange={setTimeRange} />
            </div>

            <div>
              <label>{t("logs.status_filter")}:</label>
              <select
                value={statusFilter}
                onChange={(e) => setStatusFilter(e.target.value)}
                className="form-field"
              >
                <option value="all">{t("status.all")}</option>
                <option value="approved">{t("status.approved")}</option>
                <option value="cancelled">{t("status.cancelled")}</option>
                <option value="pending">{t("status.pending")}</option>
              </select>
            </div>
          </div>

          <div className="wallets-table-wrapper" style={{ marginTop: "1rem" }}>
            <table className="wallets-table">
              <thead>
                <tr>
                  <th>{t("logs.headers.created")}</th>
                  <th>{t("logs.headers.treq_id")}</th>
                  <th>{t("logs.headers.request_id")}</th>
                  <th>{t("logs.headers.from_wallet")}</th>
                  <th>{t("logs.headers.delta_tickets_from")}</th>
                  <th>{t("logs.headers.delta_money_from")}</th>
                  <th>{t("logs.headers.to_wallet")}</th>
                  <th>{t("logs.headers.delta_tickets_to")}</th>
                  <th>{t("logs.headers.delta_money_to")}</th>
                  <th>{t("logs.headers.status")}</th>
                  <th>{t("logs.headers.notes")}</th>
                </tr>
              </thead>
              <tbody>
                {filteredLogs.map((log) => (
                  <tr key={log.treq_id}>
                    <td>
                      {new Date(log.created_at)
                        .toLocaleString("en-GB", {
                          year: "numeric",
                          month: "2-digit",
                          day: "2-digit",
                          hour: "2-digit",
                          minute: "2-digit",
                          hour12: false,
                        })
                        .replace(",", "")}
                    </td>
                    <td>{log.treq_id}</td>
                    <td>{log.treq_id}</td>
                    <td>{log.from_wallet_id}</td>
                    <td>{log.delta_tickets_from_wallet}</td>
                    <td>{log.delta_money_from_wallet}</td>
                    <td>{log.to_wallet_id}</td>
                    <td>{log.delta_tickets_to_wallet}</td>
                    <td>{log.delta_money_to_wallet}</td>
                    <td>{t(`status.${log.status}`)}</td>
                    <td>{maskLogNotes(log.notes)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
}